import { Capacitor } from '@capacitor/core';

import { SIGNED_IN_SHELL_ASSETS_ID } from './signedInShellAssets';

function readAssetList(): string[] {
	const element = document.getElementById(SIGNED_IN_SHELL_ASSETS_ID);
	if (!element) {
		return [];
	}

	// Removing the list makes every later call a no-op, including StrictMode's second effect run.
	element.remove();

	try {
		const parsed: unknown = JSON.parse(element.textContent ?? '');
		return Array.isArray(parsed) ? parsed.filter((href): href is string => typeof href === 'string') : [];
	} catch {
		return [];
	}
}

/**
 * Warms the HTTP cache with the signed-in shell while the user is still on a signed-out page. The
 * router navigates inside a transition, so without this the login page sits frozen, with no
 * spinner, while that megabyte-sized chunk graph downloads after sign-in.
 *
 * Uses fetch() rather than import(): Chromium caches a failed module fetch for the life of the
 * document, so a network blip here would break the real navigation later. A failed fetch() is
 * simply dropped. No-op in dev (no list is emitted) and on native, where the bundle is local.
 */
export function prefetchSignedInShell(): void {
	if (Capacitor.isNativePlatform()) {
		return;
	}

	for (const href of readAssetList()) {
		fetch(href, { credentials: 'same-origin', priority: 'low' })
			.then(response => response.arrayBuffer())
			.catch(() => {});
	}
}
